import { MultipleItemResponse, SingleItemResponse, fetchContent } from './fetchContent'
import { CustomProductInfo } from './models/CustomProductInfo'

type Args = {
  language: string
  dafNr: string
}

export const getProductDescription = async ({
  language,
  dafNr,
}: Args): Promise<SingleItemResponse<CustomProductInfo>> => {
  const response: MultipleItemResponse<CustomProductInfo> = await fetchContent({
    path: '',
    params: { language, limit: 1, 'elements.daf_nr': dafNr },
  })

  return {
    item: response.items[0],
    modular_content: response.modular_content,
  }
}
